import http from "./index";

export default {
  /*关键词搜索*/
  getSearchContent: function(content, start_page) {
    return http.post("/index/searchArticle", {
      content,
      start_page
    });
  }
};



// WEBPACK FOOTER //
// ./src/api/searchApi.js